"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
function SkipNavLink({ children, targetId, ...rest }) {
    return ((0, jsx_runtime_1.jsx)("a", { id: "skip-nav-link", href: `#${targetId}`, ...rest, children: children }));
}
exports.default = SkipNavLink;
